import { useState, useCallback } from 'react';
import type { AutorizacionResult } from '@/components/common/AutorizacionBadgeDialog';

interface AccionRestringida {
  funcionalidadCodigo: string;
  descripcion: string;
  aperturaCajaId?: number;
  entidad?: string;
  entidadId?: string;
}

export function useAutorizacion() {
  const [dlg, setDlg] = useState<{
    open: boolean;
    accion: AccionRestringida | null;
    resolve: ((r: AutorizacionResult) => void) | null;
  }>({ open: false, accion: null, resolve: null });

  // Solicita autorización y devuelve una Promise que resuelve con el resultado
  const solicitarAutorizacion = useCallback((accion: AccionRestringida): Promise<AutorizacionResult> => {
    return new Promise(resolve => {
      setDlg({ open: true, accion, resolve });
    });
  }, []);

  const handleAutorizado = useCallback((result: AutorizacionResult) => {
    dlg.resolve?.(result);
    setDlg({ open: false, accion: null, resolve: null });
  }, [dlg]);

  const handleCerrar = useCallback(() => {
    dlg.resolve?.({ autorizado: false });
    setDlg({ open: false, accion: null, resolve: null });
  }, [dlg]);

  return {
    solicitarAutorizacion,
    dialogProps: {
      open: dlg.open,
      onClose: handleCerrar,
      onAutorizado: handleAutorizado,
      funcionalidadCodigo: dlg.accion?.funcionalidadCodigo ?? '',
      descripcion: dlg.accion?.descripcion ?? '',
      aperturaCajaId: dlg.accion?.aperturaCajaId,
      entidad: dlg.accion?.entidad,
      entidadId: dlg.accion?.entidadId,
    },
  };
}
